import { ClientPlugin, createClient, type NormalizeOAS } from 'fets';
import type openapi from './openapi';
import { global_log_cache, LogPlugin } from './fetsLogPlugin';

function AuthPlugin(provideFunc: () => Promise<string>): ClientPlugin {
  const getToken = async () => await provideFunc();

  return {
    async onRequestInit({ requestInit }) {
      const token = await getToken();
      requestInit.headers = {
        ...requestInit.headers,
        Authorization: `Bearer ${token}`,
      };
    },
  };
}

const _createApiClient = (backendUrl: string, provideAuthTokenFunc: () => Promise<string>) => {
  return createClient<NormalizeOAS<typeof openapi>>({
    endpoint: backendUrl,
    plugins: [LogPlugin(global_log_cache), AuthPlugin(provideAuthTokenFunc)],
  });
};

type CreateAuthClientFuncType = typeof _createApiClient;
export type ApiClient = ReturnType<CreateAuthClientFuncType>;

/**
 * Create a authenticated API client for the backend.
 */
export const createApiClient = (backendUrl: string, provideFunc: () => Promise<string>): ApiClient => {
  return _createApiClient(backendUrl, provideFunc);
};
